import React from "react";

function BS4_GridXSmall() {
  return (
    <div>
      <h1>BS4_GridXSmall Component</h1>
      <p>This is the BS4_GridXSmall tutorial page content.</p>
    </div>
  );
}

export default BS4_GridXSmall;
